export const cart = {
  async add(kitParams: any) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          quantity: 1,
          ...kitParams,
        }),
      });
      return await response.json();
    } catch (error) {
      console.error(error);
    }
  },

  async get() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error(error);
    }
  },

  async update(data: any) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch (error) {
      console.error(error);
    }
  },

  async remove(id: string) {
    return this.update({ updates: { [id]: 0 } });
  },

  async clear() {
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await response.json();
    } catch (error) {
      console.error(error);
    }
  },
};
